// extracted by mini-css-extract-plugin
export var wordContainer = "_o3-0";